import { KpiIds, dbKpiId } from '@core/models/kpi.model';

import { splitKeyedName } from './vocabulary/vocabulary';

export const KPI_FIELD_PREFIX = '#assoc:kpi.';

const gbeIdOfDbName = new Map<string, string>(
  Object.entries(dbKpiId as Record<KpiIds, string>).map(([gbeId, dbName]) => [
    dbName,
    gbeId
  ])
);

/** The field name of a KPI; a keyed KPI keeps its `[key]` suffix. */
export function kpiFieldName(name: string): string {
  return `${KPI_FIELD_PREFIX}${name}`;
}

/** The KPI name inside a field name segment, `null` when the segment is not a KPI. */
export function kpiDslName(segment: string): string | null {
  return segment.startsWith(KPI_FIELD_PREFIX)
    ? segment.slice(KPI_FIELD_PREFIX.length)
    : null;
}

/** The translation key the grids use for a KPI; the key of a keyed KPI is not part of it. */
export function kpiTranslationKey(segment: string): string | null {
  const name = kpiDslName(segment);
  if (name === null) return null;
  const base = splitKeyedName(name)?.base ?? name;
  return `kpis.${gbeIdOfDbName.get(base) ?? base}`;
}
